var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconSwitch(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.25 4C12.7344 4 14.75 6.01562 14.75 8.5C14.75 10.9844 12.7344 13 10.25 13H5.75C3.24219 13 1.25 10.9844 1.25 8.5C1.25 6.01562 3.24219 4 5.75 4H10.25ZM10.25 10.75C11.4922 10.75 12.5 9.74219 12.5 8.5C12.5 7.25781 11.4922 6.25 10.25 6.25C8.98438 6.25 8 7.25781 8 8.5C8 9.74219 8.98438 10.75 10.25 10.75Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconSwitch);
export default __webpack_public_path__ + "static/media/IconSwitch.843499ce922c24583e7e885ae15b7c4e.svg";
export { ForwardRef as ReactComponent };